module.exports = __webpack_public_path__ + "img/star-half.046b1bef.svg";